import {
  CREATE_ATTACHED_FILE_INFO,
  GET_ATTACHED_FILES_INFO,
  DELETE_ATTACHED_FILE_INFO,
} from "./types";
import { UploadFileType } from "@type/HRM/upload-file";
import { AttachedFilesType } from "@type/HRM/attached-files";

//Upload
export const createAttachedFileRequest = (data: UploadFileType) => {
  return {
    type: CREATE_ATTACHED_FILE_INFO.CREATE_ATTACHED_FILE_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const createAttachedFileSuccess = (data: UploadFileType) => {
  return {
    type: CREATE_ATTACHED_FILE_INFO.CREATE_ATTACHED_FILE_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const createAttachedFileFailed = () => {
  return {
    type: CREATE_ATTACHED_FILE_INFO.CREATE_ATTACHED_FILE_INFO_FAILED,
  } as const;
};

//Fetch
export const getAttachedFilesRequest = (data: number /* Employee ID */) => {
  return {
    type: GET_ATTACHED_FILES_INFO.GET_ATTACHED_FILES_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const getAttachedFilesSuccess = (data: AttachedFilesType) => {
  return {
    type: GET_ATTACHED_FILES_INFO.GET_ATTACHED_FILES_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const getAttachedFilesFailed = () => {
  return {
    type: GET_ATTACHED_FILES_INFO.GET_ATTACHED_FILES_INFO_FAILED,
  } as const;
};

//Delete
export const deleteAttachedFileRequest = (data: any) => {
  return {
    type: DELETE_ATTACHED_FILE_INFO.DELETE_ATTACHED_FILE_INFO_REQUEST,
    payload: { data },
  } as const;
};

export const deleteAttachedFileSuccess = (data: AttachedFilesType) => {
  return {
    type: DELETE_ATTACHED_FILE_INFO.DELETE_ATTACHED_FILE_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const deleteAttachedFileFailed = () => {
  return {
    type: DELETE_ATTACHED_FILE_INFO.DELETE_ATTACHED_FILE_INFO_FAILED,
  } as const;
};

export type AttachedFilesInfoActions =
  | ReturnType<typeof createAttachedFileRequest>
  | ReturnType<typeof createAttachedFileSuccess>
  | ReturnType<typeof createAttachedFileFailed>
  | ReturnType<typeof getAttachedFilesFailed>
  | ReturnType<typeof getAttachedFilesFailed>
  | ReturnType<typeof getAttachedFilesFailed>
  | ReturnType<typeof deleteAttachedFileFailed>
  | ReturnType<typeof deleteAttachedFileFailed>
  | ReturnType<typeof deleteAttachedFileFailed>;
